import {Endpoints} from '../../../../../globals/api/endpoints';

export class FontsEndpoints extends Endpoints {

  private static readonly FONTS = FontsEndpoints.VIEWER + '/fonts';
  public static readonly FONT = FontsEndpoints.FONTS + '/' + FontsEndpoints.PROJECT_ID;
  public static readonly FONT_PREVIEW = FontsEndpoints.FONTS + '/' + FontsEndpoints.VERSION_ID + '/preview';
}
